import { Button } from '$partials/ui';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TextBlock}
 */

const Text = ({
    richText
}) => {

    return (
        <section
            className='rich-text type-style-serif-body w-full sm:w-8/9 md:w-3/4 col-padding'
            dangerouslySetInnerHTML={{ __html: richText}}/>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Text;
